module.exports = "/_next/static/images/nishan-125f0090e8a1bbe2fa31ab11922fbe35.png";